import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import api from "./api";

// Autoagenda (Cal.com): cola de solicitudes pendientes de aprobar/rechazar por recepción.
// Ver SolicitudCitaController en el backend.

const getSolicitudesPendientes = async () => {
  const { data } = await api.get("/api/v1/solicitudes-cita");
  return data?.data ?? [];
};

export const useSolicitudesCita = () => {
  return useQuery({
    queryKey: ["solicitudes-cita"],
    queryFn: getSolicitudesPendientes,
    // Autorefresh cada 30s — recepción no debería tener que apretar F5 para ver una reserva nueva.
    refetchInterval: 30000,
  });
};

export const useAprobarSolicitud = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...body }) => {
      const { data } = await api.post(
        `/api/v1/solicitudes-cita/${id}/aprobar`,
        body
      );
      return data;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["solicitudes-cita"] }),
  });
};

export const useRechazarSolicitud = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id) => {
      const { data } = await api.post(`/api/v1/solicitudes-cita/${id}/rechazar`);
      return data;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["solicitudes-cita"] }),
  });
};
